'use client';

import { LandingHeader } from '@/components/landing/header';
import { Button } from '@/components/ui/button';
import Image from "next/image"

interface DesktopPlatform {
    name: string;
    icon: string;
    downloads: { arch: string; label: string }[];
}

interface MobilePlatform {
    name: string;
    icon: string;
    description: string;
    appStore?: boolean;
    playStore?: boolean;
}

const desktopPlatforms: DesktopPlatform[] = [
    {
        name: 'Windows',
        icon: '/window.svg',
        downloads: [
            { arch: 'x86', label: 'Download (x86)' },
            { arch: 'ARM', label: 'Download (ARM)' },
        ],
    },
    {
        name: 'Linux',
        icon: '/linux.svg',
        downloads: [
            { arch: 'x86', label: 'Download (x86)' },
            { arch: 'ARM', label: 'Download (ARM)' },
        ],
    },
    {
        name: 'macOS',
        icon: '/apple.svg',
        downloads: [{ arch: 'ARM', label: 'Download (ARM)' }],
    },
];

const mobilePlatforms: MobilePlatform[] = [
    {
        name: 'iOS & iPadOS',
        icon: '/apple.svg',
        description:
            'Optimized for touch and large screens. Edit your LaTeX projects on the go.',
        appStore: true,
    },
    {
        name: 'Android',
        icon: '/android.svg',
        description:
            'Optimized for touch and large screens. Edit your LaTeX projects on the go.',
        playStore: true,
    },
];

export default function DownloadPage() {
    return (
        <>
            <main>
                <section className="bg-background py-16 md:py-24 px-4">
                    <div className="max-w-5xl mx-auto">
                        <div className="text-center mb-12">
                            <h1 className="text-4xl md:text-5xl font-bold mb-4">
                                Get the <span className="text-primary">Rudrise</span> experience
                                everywhere
                            </h1>
                            <p className="text-lg text-muted-foreground">
                                Powerful LaTeX editing, now available on all your devices.
                            </p>
                        </div>

                        {/* Desktop Version */}
                        <div className="mb-16">
                            <h2 className="text-2xl font-bold text-center mb-8">
                                Desktop Version
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {desktopPlatforms.map((platform, idx) => (
                                    <div
                                        key={idx}
                                        className="border border-border rounded-lg p-8 text-center"
                                    >
                                        <div className="mb-4 flex justify-center">
                                            <Image
                                                src={platform.icon}
                                                alt={platform.name}
                                                width={56}
                                                height={56}
                                                className="object-contain"
                                            />
                                        </div>
                                        <h3 className="text-2xl font-bold mb-4">{platform.name}</h3>
                                        <div className="space-y-3">
                                            {platform.downloads.map((download, didx) => (
                                                <Button
                                                    key={didx}
                                                    className="w-full"
                                                    variant={didx === 0 ? 'default' : 'outline'}
                                                >
                                                    {download.label}
                                                </Button>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Mobile/Tablet Version */}
                        <div>
                            <h2 className="text-2xl font-bold text-center mb-8">
                                Mobile/Tablet Version
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {mobilePlatforms.map((platform, idx) => (
                                    <div
                                        key={idx}
                                        className="border border-border rounded-lg p-8 text-center"
                                    >
                                        <div className="mb-4 flex justify-center">
                                            <Image
                                                src={platform.icon}
                                                alt={platform.name}
                                                width={56}
                                                height={56}
                                                className="object-contain"
                                            />
                                        </div>
                                        <h3 className="text-2xl font-bold mb-2">{platform.name}</h3>
                                        <p className="text-muted-foreground text-sm mb-6">
                                            {platform.description}
                                        </p>
                                        <div className="flex gap-3 justify-center">
                                            {platform.appStore && (
                                                <div
                                                    onClick={() => console.log("App Store clicked")}
                                                    className="w-[135px] h-[40px] cursor-pointer"
                                                >
                                                    <Image
                                                        src="/appStore.svg"
                                                        alt="App Store"
                                                        width={135}
                                                        height={40}
                                                        className="w-full h-full object-contain"
                                                    />
                                                </div>
                                            )}
                                            {platform.playStore && (
                                                <>
                                                    <div
                                                    onClick={() => console.log("Play Store clicked")}
                                                    className="w-[135px] h-[40px] cursor-pointer"
                                                >
                                                    <Image
                                                        src="/playStore.svg"
                                                        alt="Play Store"
                                                        width={135}
                                                        height={40}
                                                        className="w-full h-full object-contain"
                                                    />
                                                </div>
                                                   <div
                                                    onClick={() => console.log("F-Droid clicked")}
                                                    className="w-[135px] h-[40px] cursor-pointer"
                                                >
                                                    <Image
                                                        src="/fDroid.svg"
                                                        alt="F-Droid"
                                                        width={135}
                                                        height={40}
                                                        className="w-full h-full object-contain"
                                                    />
                                                </div>
                                                </>
                                            )}
                                        </div>
                                        {platform.playStore && (
                                            <Button className="w-full mt-4">Download .apk</Button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}
